<template>
  <div>
    <v-dialog v-model="dialog" min-width="350" max-width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          small
          v-bind="attrs"
          v-on="on"
          :color="btnColor"
          tabindex="-1"
        >
          <v-icon small>mdi-information-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="d-flex flex-row grey lighten-2">
          <div class="text-h5">Keratometry Information</div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="darkerCardText">
          <k-information :kObject="kObject"></k-information>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {
    KInformation: () => import("@/components/clStuff/KInformation"),
  },
  name: "KInformationPopup",
  props: {
    kObject: null,
    btnColor: {
      type: String,
      default: "primary",
    },
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
